import { Component, computed, input, InputSignal, output, OutputEmitterRef, Signal } from '@angular/core';

/** `filled` is the selected state (3px teal ring), `plain` the unselected one (thin dark ring). */
const GENDER_AVATAR_URLS: Record<string, { filled: string, plain: string }> = {
  Female: {
    filled: 'https://cdn.cureskin.com/app/img/female_filled.svg',
    plain: 'https://cdn.cureskin.com/app/img/female_plain.svg',
  },
  Male: {
    filled: 'https://cdn.cureskin.com/app/img/male_filled.svg',
    plain: 'https://cdn.cureskin.com/app/img/male_plain.svg',
  },
};

/** One selectable gender card. The label is projected so its i18n stays on the page template. */
@Component({
  selector: 'app-onboarding-gender-card',
  templateUrl: './onboarding-gender-card.component.html',
  host: { class: 'tw-flex tw-flex-1' },
})
export class OnboardingGenderCardComponent {
  /** An `AppConfig.Shared.Gender` value — keys the avatar pair. */
  readonly gender: InputSignal<string> = input.required<string>();

  readonly selected: InputSignal<boolean> = input.required<boolean>();

  readonly genderSelected: OutputEmitterRef<string> = output<string>();

  /** Both avatars render stacked and cross-fade on selection; swapping one `src` cannot animate. */
  protected readonly plainAvatarUrl: Signal<string> = computed(
    (): string => GENDER_AVATAR_URLS[this.gender()]?.plain ?? '',
  );

  protected readonly filledAvatarUrl: Signal<string> = computed(
    (): string => GENDER_AVATAR_URLS[this.gender()]?.filled ?? '',
  );

  protected handleSelect(): void {
    this.genderSelected.emit(this.gender());
  }
}
